import React from 'react';
import { ChevronLeft, ChevronDown, CheckCircle2, ShieldCheck } from 'lucide-react';
interface ScreenProps {
  onNavigate: (screenId: number) => void;
}
export function Screen4({
  onNavigate
}: ScreenProps) {
  return <div className="min-h-full bg-slate-50 flex flex-col pb-24" data-id="element-154">
      {/* Header */}
      <div className="px-4 py-4 bg-white flex items-center sticky top-0 z-10 border-b border-slate-100" data-id="element-155">
        <button onClick={() => onNavigate(3)} className="p-2 -ml-2 text-slate-600 hover:bg-slate-50 rounded-full transition-colors" data-id="element-156">
          <ChevronLeft className="w-6 h-6" data-id="element-157" />
        </button>
        <h1 className="text-base font-bold text-datmont-900 ml-2" data-id="element-158">
          Submit for Verification
        </h1>
      </div>

      <div className="flex-1 px-6 py-6 space-y-8" data-id="element-159">
        {/* Step 1 */}
        <div data-id="element-160">
          <h2 className="text-sm font-bold text-datmont-900 mb-1" data-id="element-161">
            1. Select Institution
          </h2>
          <p className="text-xs text-slate-500 mb-3" data-id="element-162">Visa Processing Center</p>

          <div className="w-full bg-white border border-slate-200 rounded-xl p-3.5 flex items-center justify-between shadow-sm cursor-pointer hover:border-datmont-blue/50 transition-colors" data-id="element-163">
            <div className="flex items-center gap-3" data-id="element-164">
              <div className="w-8 h-8 rounded-full bg-datmont-900 flex items-center justify-center text-white text-[10px] font-bold" data-id="element-165">
                VFS
              </div>
              <span className="text-sm font-medium text-datmont-900" data-id="element-166">
                VFS Global – Madrid, Spain
              </span>
            </div>
            <ChevronDown className="w-5 h-5 text-slate-400" data-id="element-167" />
          </div>
        </div>

        {/* Step 2 */}
        <div data-id="element-168">
          <h2 className="text-sm font-bold text-datmont-900 mb-3" data-id="element-169">
            2. Purpose of Submission
          </h2>

          <div className="w-full bg-white border border-slate-200 rounded-xl p-4 flex items-center justify-between shadow-sm cursor-pointer hover:border-datmont-blue/50 transition-colors" data-id="element-170">
            <span className="text-sm font-medium text-datmont-900" data-id="element-171">
              Visa Application – Work Visa
            </span>
            <ChevronDown className="w-5 h-5 text-slate-400" data-id="element-172" />
          </div>
        </div>

        {/* Step 3 */}
        <div data-id="element-173">
          <h2 className="text-sm font-bold text-datmont-900 mb-3" data-id="element-174">
            3. Select Document
          </h2>

          <div className="w-full bg-white border-2 border-datmont-blue rounded-xl p-4 flex items-center justify-between shadow-sm relative overflow-hidden" data-id="element-175">
            <div className="absolute inset-0 bg-blue-50/50 pointer-events-none" data-id="element-176"></div>
            <div className="flex items-center gap-4 relative z-10" data-id="element-177">
              <div className="w-12 h-12 rounded-full bg-slate-800 flex items-center justify-center text-white font-serif font-bold text-xs border-2 border-yellow-500 shadow-sm" data-id="element-178">
                FBI
              </div>
              <div data-id="element-179">
                <p className="text-sm font-bold text-datmont-900" data-id="element-180">
                  FBI Identity Record
                </p>
                <p className="text-[10px] text-slate-500 mt-0.5" data-id="element-181">
                  Issued: 03/12/2024
                </p>
                <p className="text-[10px] text-slate-400 font-mono mt-0.5" data-id="element-182">
                  DMT-8847291
                </p>
              </div>
            </div>
            <div className="w-6 h-6 rounded-full bg-datmont-blue flex items-center justify-center relative z-10" data-id="element-183">
              <CheckCircle2 className="w-4 h-4 text-white" data-id="element-184" />
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Action */}
      <div className="absolute bottom-0 inset-x-0 bg-white border-t border-slate-100 p-4" data-id="element-185">
        <button onClick={() => onNavigate(5)} className="w-full py-4 bg-datmont-900 text-white text-sm font-medium rounded-xl flex items-center justify-center gap-2 shadow-md hover:bg-datmont-800 transition-colors" data-id="element-186">
          <ShieldCheck className="w-5 h-5" data-id="element-187" /> Send with Datmont Verification
        </button>
      </div>
    </div>;
}